import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_ROOT = `${BACKEND_URL}/api`;

export const api = axios.create({
    baseURL: API_ROOT,
    withCredentials: true,
});

export function setAuthToken(token) {
    if (token) {
        api.defaults.headers.common.Authorization = `Bearer ${token}`;
        try { localStorage.setItem("pv_token", token); } catch {}
    } else {
        delete api.defaults.headers.common.Authorization;
        try { localStorage.removeItem("pv_token"); } catch {}
    }
}

// bootstrap from localStorage
try {
    const t = localStorage.getItem("pv_token");
    if (t) api.defaults.headers.common.Authorization = `Bearer ${t}`;
} catch {}
